export default {
  // 공통
  common: {
    save: '저장',
    cancel: '취소',
    delete: '삭제',
    edit: '수정',
    add: '추가',
    search: '검색',
    loading: '불러오는 중...',
    noData: '데이터가 없습니다.',
    confirm: '확인',
    close: '닫기',
    more: '더보기',
  },

  // 헤더
  header: {
    allProducts: '전체상품',
    best: '베스트',
    newArrival: '신상품',
    cart: '장바구니',
    mypage: '마이페이지',
    admin: '관리자',
    login: '로그인',
    register: '회원가입',
    logout: '로그아웃',
    products: '제품',
    groupBuys: '한정판매',
    proxyBuy: '대리구매',
    faq: '이용안내',
    support: '고객지원',
    event: '이벤트',
  },

  // 홈
  home: {
    heroTitle: '아름다움을 위한\n특별한 선택',
    heroSub: '뷰티 전문 쇼핑몰에서 나만의 뷰티 루틴을 찾아보세요',
    searchPlaceholder: '상품명, 브랜드로 검색하세요',
    category: '카테고리',
    bestProducts: '🏆 베스트 상품',
    newProducts: '✨ 신상품',
    noProducts: '등록된 상품이 없습니다.',
  },

  // 카테고리
  categories: {
    skincare: '스킨케어',
    makeup: '메이크업',
    suncare: '선케어',
    haircare: '헤어케어',
    bodycare: '바디케어',
    perfume: '향수',
    mensBeauty: '남성뷰티',
    beautyTools: '뷰티도구',
  },

  // 상품
  product: {
    brand: '브랜드',
    price: '가격',
    salePrice: '할인가',
    discount: '% 할인',
    stock: '재고',
    inStock: '개 남음',
    outOfStock: '품절',
    variant: '디자인',
    selectVariant: '디자인을 선택해주세요',
    quantity: '수량',
    total: '합계',
    addToCart: '🛒 장바구니',
    buyNow: '바로 구매',
    detail: '상품 상세',
    reviews: '리뷰',
    noDescription: '상세 설명이 없습니다.',
    noReviews: 'No reviews yet.',
    addingCart: '담는 중...',
    cartAdded: '장바구니에 담겼습니다!',
    cartAddFailed: '장바구니에 담지 못했습니다. 다시 시도해주세요.',
    reviewCount: '리뷰 {{count}}개',
    viewCount: '조회 {{count}}',
  },

  // 상품 목록
  productList: {
    all: '전체',
    latest: '최신순',
    best: '베스트',
    newArrival: '신상품',
    sort: '정렬',
    itemCount: '개 상품',
    noResults: '🔍 검색 결과가 없습니다.',
    searchResults: '검색 결과',
  },

  // 장바구니
  cart: {
    title: '장바구니',
    empty: '장바구니가 비어있습니다.',
    goShopping: '쇼핑하러 가기',
    subtotal: '상품 합계',
    shipping: '배송비',
    freeShipping: '무료',
    totalWeight: '총 무게',
    selectAll: '전체 선택',
    calcAtCheckout: '결제 시 계산',
    total: '총 결제금액',
    checkout: '주문하기',
    freeShippingGuide: '무료 배송 적용!',
    freeShippingRemain: '원 더 구매시 무료배송',
    loginRequired: '로그인을 해주세요',
    goLogin: '로그인하러 가기',
  },

  // 주문
  order: {
    title: '주문/결제',
    delivery: '배송 정보',
    receiverName: '수령인',
    receiverPhone: '전화번호',
    zipCode: '우편번호',
    address: '주소',
    addressDetail: '상세주소',
    memo: '배송 메모',
    memoPlaceholder: '배송 요청사항',
    payment: '결제 수단',
    coupon: '쿠폰',
    couponPlaceholder: '쿠폰 코드 입력',
    orderProducts: '주문 상품',
    pay: '원 결제하기',
    processing: '처리 중...',
    success: '주문이 완료되었습니다!',
    failed: '주문 실패',
    methods: {
      CARD: '신용/체크카드',
      STRIPE: '해외 카드 (Stripe)',
      BANK_TRANSFER: '무통장 입금',
      KAKAO_PAY: '카카오페이',
      NAVER_PAY: '네이버페이',
      PAYPAL: 'PayPal',
    },
    paypalInfo: 'PayPal 버튼을 클릭하면 PayPal 결제창이 열립니다.',
    stripeAmount: 'Stripe 결제 금액',
    stripeLoading: '결제 정보를 불러오는 중...',
    fillRequired: '배송 정보를 모두 입력해주세요.',
  },

  // 로그인/회원가입
  auth: {
    loginTitle: '로그인',
    loginSub: 'Moa에 오신 것을 환영합니다',
    registerTitle: '회원가입',
    registerSub: 'Moa 회원이 되어 다양한 혜택을 누리세요',
    email: '이메일',
    emailPlaceholder: '이메일을 입력하세요',
    password: '비밀번호',
    passwordPlaceholder: '비밀번호를 입력하세요',
    passwordHint: '8자 이상',
    name: '이름',
    namePlaceholder: '이름',
    phone: '전화번호',
    phonePlaceholder: '(555) 000-0000',
    loginBtn: '로그인',
    registerBtn: '회원가입',
    loggingIn: '로그인 중...',
    processing: '처리 중...',
    sendCode: '인증코드 받기',
    sendingCode: '전송 중...',
    resendCode: '재전송',
    codeSent: '인증코드를 보냈어요. 이메일을 확인해 주세요 (5분간 유효).',
    codeSendFailed: '코드 전송 실패',
    emailRequired: '이메일을 먼저 입력해 주세요',
    verifyCode: '인증코드',
    verifyCodePlaceholder: '6자리 코드',
    noAccount: '아직 회원이 아닌가요?',
    hasAccount: '이미 회원이신가요?',
    goRegister: '회원가입',
    goLogin: '로그인',
  },

  // 마이페이지
  mypage: {
    title: '주문 내역',
    noOrders: '주문 내역이 없습니다.',
    goShopping: '쇼핑하러 가기',
    orderNumber: '주문번호',
    viewDetail: '상세 보기',
    orderTotal: '총',
  },

  // 주문 상세 / 취소 / 환불 / 배송
  orderDetail: {
    title: '주문 상세',
    backToList: '← 주문 내역으로',
    orderProducts: '주문 상품',
    delivery: '배송 정보',
    payment: '결제 정보',
    receiverName: '수령인',
    receiverPhone: '전화번호',
    address: '주소',
    memo: '배송 메모',
    paymentMethod: '결제 수단',
    productAmount: '상품 금액',
    shipping: '배송비',
    couponDiscount: '쿠폰 할인',
    finalAmount: '총 결제금액',
    notFound: '주문을 찾을 수 없습니다.',
    tracking: '배송 조회',
    trackingNumber: '운송장 번호',
    courier: '택배사',
    trackingView: '배송 추적 보기',
    trackingEmpty: '아직 배송 정보가 없습니다.',
    trackingClose: '닫기',
    trackingUspsHint: '미국 내 배송 현황은 USPS에서도 같은 번호로 조회할 수 있습니다.',
    trackingUspsLink: 'USPS에서 조회',
    packingVideo: '포장 영상',
    packingVideoView: '영상 보기',
    cancelBtn: '주문 취소',
    cancelTitle: '주문을 취소하시겠습니까?',
    cancelReason: '취소 사유 (선택)',
    cancelReasonPlaceholder: '취소 사유를 입력해주세요',
    cancelConfirm: '취소하기',
    cancelSuccess: '주문이 취소되었습니다.',
    cancelFailed: '주문 취소에 실패했습니다.',
    cancelledAt: '취소일',
    cancelReasonLabel: '취소 사유',
    refundBtn: '환불 요청',
    refundTitle: '환불을 요청하시겠습니까?',
    refundReason: '환불 사유',
    refundReasonPlaceholder: '환불 사유를 입력해주세요 (필수)',
    refundConfirm: '환불 요청',
    refundSuccess: '환불 요청이 접수되었습니다.',
    refundFailed: '환불 요청에 실패했습니다.',
    refundRequestedAt: '환불 요청일',
    refundReasonLabel: '환불 사유',
  },

  // 리뷰
  review: {
    write: '리뷰 작성',
    writeTitle: '리뷰를 남겨주세요',
    ratingLabel: '별점',
    contentLabel: '내용',
    contentPlaceholder: '상품에 대한 솔직한 후기를 남겨주세요. (10자 이상)',
    submit: '등록',
    submitting: '등록 중...',
    success: '리뷰가 등록되었습니다.',
    duplicate: '이미 작성한 리뷰가 있습니다.',
    deleteConfirm: '리뷰를 삭제하시겠습니까?',
    deleted: '리뷰가 삭제되었습니다.',
    loginRequired: '로그인 후 리뷰를 작성하실 수 있습니다.',
    contentMin: '리뷰는 10자 이상 입력해주세요.',
  },

  // 주문 상태
  orderStatus: {
    PENDING: '결제 대기',
    PAID: '결제 완료',
    PREPARING: '상품 준비중',
    SHIPPING: '배송중',
    DELIVERED: '배송 완료',
    CANCELLED: '취소됨',
    REFUND_REQUESTED: '환불 요청됨',
    REFUNDED: '환불됨',
  },

  // 장바구니 추천
  cartRecommend: {
    youMightLike: '같이 보면 좋은 상품',
    customersBought: '이 상품을 구매한 고객이 함께 구매한 상품',
  },

  // 플로팅 카트
  floatingCart: {
    title: '장바구니',
    empty: '담긴 상품이 없습니다',
    total: '합계',
    checkout: '결제하기',
    viewCart: '장바구니 보기',
  },

  // 이벤트
  events: {
    title: '이벤트',
    noEvents: '진행 중인 이벤트가 없습니다.',
    shopNow: '쇼핑하기',
    products: '개 상품',
    endsAt: '종료일',
    backToEvents: '← 이벤트 목록',
    noProducts: '이벤트 상품이 없습니다.',
    notFound: '이벤트를 찾을 수 없습니다.',
  },

  // 할인
  sale: {
    title: '할인 상품',
    badge: '% 할인',
  },

  // 푸터
  footer: {
    cs: '고객센터',
    csHours: '평일 09:00~18:00',
    rights: '© 2026 Moa. All rights reserved.',
    partnership: '입점문의',
    privacy: '개인정보처리방침',
    terms: '이용약관',
    contentSoon: '내용 준비 중입니다.',
  },
};
